import { ChargingRulesServiceInterface } from "interfaces/charging-rules-service"
import { CommunicationService } from "services/mms/mock/CommunicationService.ts"
import { BaseMmsMockService } from "./BaseMockService.ts"

export class MockChargingRulesService extends BaseMmsMockService
    implements ChargingRulesServiceInterface {

    constructor(communicationService: CommunicationService) {
        super(communicationService)
    }
    
    useGetListChargingRules() {
        return {
            data: [],
            isLoading: false,
            error: null,
            refetch: vi.fn(),
            sendRequest: vi.fn().mockResolvedValue({ data: [], success: true, status: 200 }),
            success: true,
            status: 200
        }
    }

    useUpdateChargingRule() {
        return {
            data: {},
            mutate: vi.fn(),
            isLoading: false,
            error: null,
            sendRequest: vi.fn().mockResolvedValue({ data: {}, success: true, status: 200 }),
            success: true,
            status: 200
        }
    }
}